/* Facets Drawer — open/close + auto-submit sort */

/* Widgets flotantes que tapan el drawer. El chat y el agente de Shopify se
   pintan con z-index 2147483647 (el máximo), así que no hay z-index que los
   supere: hay que ocultarlos mientras el drawer está abierto. */
const FACETS_CHAT_SELECTORS = [
  'shopify-chat',
  'shopify-agent',
  '#shopify-chat',
  '#shopify-chat-app',
  '#shopify-element-wrapper',
  '#chat-widget-container',
  '.shopify-chat',
  'iframe[id^="chat"]',
  'iframe[name^="chat"]',
].join(',');

/* Red de seguridad para widgets de apps que no conocemos: cualquier elemento
   suelto en <body> que flote por encima de todo. Se restaura al cerrar. */
function floatingWidgets() {
  return Array.prototype.filter.call(document.body.children, (el) => {
    if (el.closest('facets-drawer') || el.matches('script, style, link, noscript')) return false;
    const styles = getComputedStyle(el);
    if (styles.position !== 'fixed' && !el.tagName.startsWith('SHOPIFY-')) return false;
    return parseInt(styles.zIndex, 10) >= 100000 || el.tagName.startsWith('SHOPIFY-');
  });
}

class FacetsDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-facets-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }
  toggleChat(hide) {
    const targets = new Set(document.querySelectorAll(FACETS_CHAT_SELECTORS));
    floatingWidgets().forEach((el) => targets.add(el));
    targets.forEach((el) => {
      el.style.visibility = hide ? 'hidden' : '';
      el.style.pointerEvents = hide ? 'none' : '';
    });
  }
  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('facets-drawer-open');
    this.toggleChat(true);
  }
  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('facets-drawer-open');
    this.toggleChat(false);
  }
}
if (!customElements.get('facets-drawer')) customElements.define('facets-drawer', FacetsDrawer);

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-facets-open]');
  if (!opener) return;
  const drawer = document.querySelector('facets-drawer');
  if (!drawer) return;
  e.preventDefault();
  drawer.open();
});

// Auto-submit sort form
document.addEventListener('change', (e) => {
  const sortForm = e.target.closest('[data-sort-form]');
  if (!sortForm) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortForm.querySelector('select').value);
  window.location.href = url.toString();
});

// Apply filters — build a clean URL (drop empty values, keep current sort)
document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-facets-form]');
  if (!form) return;
  e.preventDefault();

  const base = form.getAttribute('action') || window.location.pathname;
  const url = new URL(base, window.location.origin);

  // Preserve the active sort, which lives outside this form.
  const currentSort = new URL(window.location.href).searchParams.get('sort_by');
  if (currentSort) url.searchParams.set('sort_by', currentSort);

  new FormData(form).forEach((value, key) => {
    if (value !== null && String(value).trim() !== '') {
      url.searchParams.append(key, value);
    }
  });

  window.location.href = url.toString();
});
